import { httpClient } from '@/services/http/httpClient'

export async function readUserNotification(id: string): Promise<void> {
  await httpClient.patch(`/events/v2/${id}`)
}
